"use client"

import React from 'react';
import usePrayersData from "@/utils/hooks/usePrayersData";
import {useAppStore} from "@/store/AppStore";
import {Prayer} from "@/types/Prayers";
import {TreeItem} from "@mui/x-tree-view/TreeItem";
import {CircularProgress} from "@mui/material";

export default function PrayersItems() {

  const user = useAppStore((state) => state.user);
  const data = usePrayersData(user?.access_token)

  const items = data?.items

  if (!user) return null
  if (!data) return <CircularProgress/>

  return (
    <>
      {items && items.map((itm: Prayer, key: number) => {
        return <TreeItem key={key} label={itm.name} itemId={`prayer-${itm.id}`}/>
      })
      }
    </>
  )
}
